export default "/static/034f5087d6d6e052.svg"